import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {
    assetsDialogsSelector,
    cleanVirtualAssets,
    hideExportCsv,
    loadings,
    minMaxLoadedPage,
    openExportCsv,
    openReleaseDialog,
    pageInfoSelector,
    replaceMinMaxLoadedPage,
    selectVirtualAsset,
    setImportCsvDialogAction,
    virtualAssetsSelector,
    virtualAssetsSettingsSelector
} from "../../store/store";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {TVirtualAsset} from "../../types";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS,
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_ID,
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_NEW,
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_SETTINGS
} from "../../constants";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import React, {useEffect, useState} from "react";
import {
    exportCsvVirtualAssetsAction,
    getVirtualAssetsAction,
    GetVirtualAssetsAvailableFieldsForExport,
    getVirtualAssetsSettingsAction
} from "../../store/actions";
import {CommonFilterType, minMaxLoadedPageType} from "../../../../../newShared/components/genericTable/types";


export const useVirtualAssetsList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isLoadingList, isLoadingSettings, isLoadingExport, isLoadingFields} = useSelector(loadings);
    const virtualAssets = useSelector(virtualAssetsSelector);
    const _pageInfo = useSelector(pageInfoSelector);
    const dialogs = useSelector(assetsDialogsSelector);


    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: tMenu('Virtual assets'),
            path: PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS
        },
    ]);

    // const controller = new AbortController();

    //search and filters
    // const [filter, setFilter] = useState<TCommonAssetsFilter>({
    //     nameLike: '',
    //     prevSearch: '',
    //     type: '',
    // })


    // const getAssets = (page: number, count: number, _filter: TCommonAssetsFilter, enterDown: boolean) => {
    //     !isLoadingList && dispatch(getVirtualAssetsAction({data: {
    //             page,
    //             count,
    //             filters: {
    //                 nameLike: enterDown && _filter.nameLike ?  [_filter.nameLike] : (!enterDown && _filter.prevSearch ? [_filter.prevSearch] : []),
    //                 type: (_filter.type && _filter.type !== 'Any') ? [_filter.type] : [],
    //             }}, signal: controller.signal}))
    //     !isLoadingList && setFilter({..._filter, prevSearch: enterDown && _filter.nameLike ? _filter.nameLike  : (!enterDown && _filter.prevSearch ? _filter.prevSearch : '')})
    // }

    const getSettings = (signal?: AbortSignal) => {dispatch(getVirtualAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal}))}

    // const clean = () => dispatch(cleanUp());

    const goToAsset = (asset: TVirtualAsset) => {
        if(asset) {
            dispatch(selectVirtualAsset(asset));
            history.push(`${PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_ID.replace(':id', asset.id)}`);
        }
    }

    useEffect(() => {
        !isLoadingList && getSettings();

        // return () => {
        //     clean();
        // }
        //eslint-disable-next-line
    }, []);

    const goToAddAsset = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_NEW);
    const goToSettings = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_SETTINGS);


    //MENU
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // const exportCsv = () => {
    //     handleClose();
    //     dispatch(exportCsvVirtualAssetsAction())
    // };

    const handleOpenExportCsv = () => {
        dispatch(openExportCsv());
        dispatch(GetVirtualAssetsAvailableFieldsForExport());
    }

    const handleExportCsv = (fieldKeys: string[]) => {
        handleClose();
        dispatch(exportCsvVirtualAssetsAction({fieldKeys, isDownload: _pageInfo.total < 10000}))
    };

    const handleCloseExportCsv = () => {
        dispatch(hideExportCsv());
    }

    const handleImportCSV = () => {
        handleClose();
        dispatch(setImportCsvDialogAction({isOpen: true}));
    }

    //filters
    // const setSearch = (search: string) => setFilter({...filter, nameLike: search});
    //
    // const handleCleanSearch = () => {
    //     const newFilter = {...filter, nameLike: '', prevSearch: ''};
    //     setFilter(newFilter);
    //     getAssets(0, DEFAULT_COUNT, newFilter, false);
    // }
    //
    // const handleEnterKey = (e: any) => {
    //     if(e.keyCode === 13){
    //         getAssets(0, DEFAULT_COUNT, filter, true);
    //     }
    // }
    //
    // const handleOnChangeType = (type: string) => {
    //     if (type === 'Any') {
    //         const newFilter = {...filter, type: '' };
    //         setFilter(newFilter);
    //         getAssets(0, DEFAULT_COUNT, newFilter, false);
    //     }
    //     if (type !== 'Any') {
    //         const newFilter = {...filter, type};
    //         setFilter(newFilter);
    //         getAssets(0, DEFAULT_COUNT, newFilter, false);
    //     }
    // }

    const handleOpenRelease = () => {
        dispatch(openReleaseDialog({assetType: 'virtual'}));
        handleClose();
    }

    // // pagination
    // const {bottomLoader, onScroll, scrollRef} = useScrollPagination({
    //     getData: ({page, count}) => {
    //         getAssets(
    //             page, count, filter,false
    //         )
    //     },
    //     arrayLength: virtualAssets.length,
    //     isLoading: isLoadingList,
    //     pageInfo: _pageInfo,
    //     cleanData: () => {},
    //
    // })

    const {minLoadedPage, maxLoadedPage} = useSelector(minMaxLoadedPage);

    return {
        settings: useSelector(virtualAssetsSettingsSelector),
        // setSearch,
        // hasMore: _pageInfo.total > ((_pageInfo.page + 1) * _pageInfo.count),
        virtualAssets,
        goToAsset,
        goToAddAsset,
        goToSettings,
        // importCsv,
        handleImportCSV,
        handleOpenRelease,
        handleOpenExportCsv,

        menu: {
            anchorEl,
            handleClose,
            handleClick,
            open,
        },

        // filter: {
        //     filter,
        //     setFilter,
        //     setSearch,
        //     handleEnterKey,
        //     handleCleanSearch,
        //     handleOnChangeType,
        // },

        exportCsv: {
            isOpen: dialogs.exportCsv.isOpen,
            availableFields: dialogs.exportCsv.fields,
            handleExportCsv,
            handleClose: handleCloseExportCsv,
        },

        isLoadingList,
        isLoadingFields,
        // isShowingNoAssets: !isLoadingList && virtualAssets.length === 0 && !filter.prevSearch && !filter.type?.length && !filter.nameLike.length,
        isLoadingSettings,
        // handleLoadMore,
        isLoadingExport,

        // pagination: {
        //     bottomLoader: bottomLoader && virtualAssets.length < _pageInfo.total,
        //     onScroll,
        //     scrollRef
        // },
        genericTable: {
            paging: {
                pageInfo: _pageInfo,
                isLoading: isLoadingList,
                minLoadedPage,
                maxLoadedPage,
                setMinMaxLoadedPage: (data: minMaxLoadedPageType) => dispatch(replaceMinMaxLoadedPage(data)),
                clearRows: () => dispatch(cleanVirtualAssets()),
                fetchPaging: (page: number, count: number, filters: CommonFilterType, search: string) => {
                    dispatch(getVirtualAssetsAction({data: {page, count, filters}}));
                },
            },
        }

    }


}
